<template>
    <div class="flex flex-col flex-wrap items-center justify-start w-full px-4 md:flex-row">
        <div class="w-full md:w-6/12">
            <div v-if="!selectedLocation" class="pr-4 text-4xl font-bold text-pink-600">Clicca sulla tua regione<br> per trovare un evento <br><span class="text-lg text-gray-800 inline-block pt-3">o conduci una ricerca per <a href="https://eventiosm.it/speakers" class="underline text-pink-600">speaker</a>, per <a href="#themes" class="underline text-pink-600">tema</a> oppure <a href="https://eventiosm.it/online" class="underline text-pink-600">online</a></span>
            </div>
            <div v-else class="pr-4 text-4xl font-bold text-pink-600">Cerca un evento<br>nella regione</div>
            <div v-if="selectedLocation == 'aosta-valley'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Valle d'Aosta</span>
                <a href="/region/19" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'piedmont'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Piemonte</span> 
                <a href="/region/12" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'liguria'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Liguria</span> 
                <a href="/region/8" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'lombardy'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Lombardia</span> 
                <a href="/region/9" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'trentino-south-tyrol'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Trentino Alto Adige</span> 
                <a href="/region/17" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'veneto'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Veneto</span> 
                <a href="/region/20" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'friuli-venezia-giulia'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Friuli Venezia Giulia</span> 
                <a href="/region/6" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'tuscany'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Toscana</span> 
                <a href="/region/16" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'emilia-romagna'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Emilia Romagna</span> 
                <a href="/region/5" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'marche'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Marche</span> 
                <a href="/region/10" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'umbria'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Umbria</span> 
                <a href="/region/18" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'lazio'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Lazio</span> 
                <a href="/region/7" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'abruzzo'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Abruzzo</span> 
                <a href="/region/1" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'molise'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Molise</span> 
                <a href="/region/11" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'apulia'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Puglia</span> 
                <a href="/region/13" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'campania'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Campania</span> 
                <a href="/region/4" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'basilicata'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Basilicata</span> 
                <a href="/region/2" class="block px-6 py-1 mt-4 font-bold text-center text-white bg-green-500 shadow-xl mb-2text-sm w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'calabria'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Calabria</span> 
                <a href="/region/3" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'sicily'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Sicilia</span> 
                <a href="/region/15" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
            <div v-if="selectedLocation == 'sardinia'">
                <span class="pr-4 text-6xl font-bold text-pink-600">Sardegna</span> 
                <a href="/region/14" class="block px-6 py-1 mt-4 mb-2 text-sm font-bold text-center text-white bg-green-500 shadow-xl w-36 rounded-xl hover:bg-pink-600 hover:shadow-custom">trova eventi</a>
            </div>
        </div>
        <div class="w-full md:w-6/12">
            <RadioSvgMap :map="Italy" v-model="selectedLocation" />
        </div>
    </div>
</template>

<script>
import { RadioSvgMap } from "vue-svg-map";
import Italy from "@svg-maps/italy";

export default {
    components: {
        RadioSvgMap,
    },
    data() {
        return {
            Italy,
            selectedCategory: null,
            selectedLocation: null,
        };
    },
}
</script>

<style src="vue-svg-map/dist/index.css"></style>
<style scoped>
    .category-icon:hover {
        filter: invert(1);
    }
</style>